import { MonthYear } from "@common/types";
import { ICommandBase } from "@Alternatives/cqrs";
import { AlternativeAttributeValueDTO } from "@Alternatives/Model";


export class CreateAlternativeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.CreateAlternativeCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	FormDefinitionId: number;
	Id: string;
	Name: string;
	Description: string;
	StatusId: number;
	AttributesValues: AlternativeAttributeValueDTO[];

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, formDefinitionId: number, id: string, name: string, desc: string, statusId: number, attributesValues: AlternativeAttributeValueDTO[])
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.FormDefinitionId = formDefinitionId;
		this.Id = id;
		this.Name = name;
		this.Description = desc;
		this.StatusId = statusId;
		this.AttributesValues = attributesValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.CreateAlternativeCommandV1, TCh.Domain.Alternatives';
	}
}

export class DeleteAlternativeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.DeleteAlternativeCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, id: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = id;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.DeleteAlternativeCommandV1, TCh.Domain.Alternatives';
	}
}



export class ChangeStatusCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.ChangeStatusCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	AlternativeId: number;
	NewStatusId: number;

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, id: string, alternativeId: number, newStatusId: number)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = id;
		this.AlternativeId = alternativeId;
		this.NewStatusId = newStatusId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.ChangeStatusCommandV1, TCh.Domain.Alternatives';
	}
}

export class UpdateAlternativeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.UpdateAlternativeCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	FormDefinitionId: number;
	Id: string;
	Name: string;
	Description: string;
	StatusId: number;
	AttributesValues: AlternativeAttributeValueDTO[];

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, formDefinitionId: number, id: string, name: string, desc: string, statusId: number, attributesValues: AlternativeAttributeValueDTO[])
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.FormDefinitionId = formDefinitionId;
		this.Id = id;
		this.Name = name;
		this.Description = desc;
		this.StatusId = statusId;
		this.AttributesValues = attributesValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.UpdateAlternativeCommandV1, TCh.Domain.Alternatives';
	}
}


export class UpdateAlternativeAttributeValueCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.UpdateAlternativeAttributeValueCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	AlternativeId: number;
	AttributeId: number;
	CurrValue: string;
	NewValue: string;

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, id: string, alternativeId: number, attributeId: number, currValue: string, newValue: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = id;
		this.AlternativeId = alternativeId;
		this.AttributeId = attributeId;
		this.CurrValue = currValue;
		this.NewValue = newValue;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.UpdateAlternativeAttributeValueCommandV1, TCh.Domain.Alternatives';
	}
}



export class CreateNoteCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.CreateNoteCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string; 
	NoteId: string;
	NoteBody: string;

	constructor(workspaceId: number, projectId: number, alternativeId: string, noteId: string, noteBody: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativeId;
		this.NoteId = noteId;
		this.NoteBody = noteBody;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.CreateNoteCommandV1, TCh.Domain.Alternatives';
	}
}

export class DeleteAttachedDocumentCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.DeleteAttachedDocumentCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	AlternativesListId: number;
	Id: string; 
	AttachmentId: string;

	constructor(userId: number, workspaceId: number, alternativesListId: number, alternativeId: string, attachmentId: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.AlternativesListId = alternativesListId;
		this.Id = alternativeId;
		this.AttachmentId = attachmentId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.DeleteAttachedDocumentCommandV1, TCh.Domain.Alternatives';
	}
}

export class SendEmailCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.SendEmailCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	AlternativesListId: number;
	Id: string; 
	Subject: string;
	ReplyTo: string;
	To: string[];
	BodyHtml: string;

	constructor(userId: number, workspaceId: number, alternativesListId: number, id: string, subject: string, replyTo: string, to: string[], bodyHtml: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.AlternativesListId = alternativesListId;
		this.Id = id;
		this.Subject = subject;
		this.ReplyTo = replyTo;
		this.To = to;
		this.BodyHtml = bodyHtml;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.SendEmailCommandV1, TCh.Domain.Alternatives';
	}
}

export class AddAttachedDocumentCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.AddAttachedDocumentCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	AlternativesListId: number;
	Id: string;
	AttachmentId: string;
	BlobId: string;

	constructor(userId: number, workspaceId: number, alternativesListId: number, id: string, attachmentId: string, blobId: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.AlternativesListId = alternativesListId;
		this.Id = id;
		this.AttachmentId = attachmentId;
		this.BlobId = blobId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.AddAttachedDocumentCommandV1, TCh.Domain.Alternatives';
	}
}

export class LinkFoundationAlternativeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.LinkFoundationAlternativeCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	FoundationId: string;

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, fAlternativeId: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = alternativeId;
		this.FoundationId = fAlternativeId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.LinkFoundationAlternativeCommandV1, TCh.Domain.Alternatives';
	}
}

export class UnlinkFoundationAlternativeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.UnlinkFoundationAlternativeCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	FoundationId: string;

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, fAlternativeId: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = alternativeId;
		this.FoundationId = fAlternativeId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.UnlinkFoundationAlternativeCommandV1, TCh.Domain.Alternatives';
	}
}

export class LinkDependentAlternativeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.LinkDependentAlternativeCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	DependentId: string;

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, dAlternativeId: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = alternativeId;
		this.DependentId = dAlternativeId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.LinkDependentAlternativeCommandV1, TCh.Domain.Alternatives';
	}
}

export class UnlinkDependentAlternativeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.UnlinkDependentAlternativeCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	DependentId: string;

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, dAlternativeId: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = alternativeId;
		this.DependentId = dAlternativeId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.UnlinkDependentAlternativeCommandV1, TCh.Domain.Alternatives';
	}
}

export class UpdateAlternativeStartDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.UpdateAlternativeStartDateCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	StartDate: MonthYear | null;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, startDate: MonthYear | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = alternativeId;
		this.StartDate = startDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.UpdateAlternativeStartDateCommandV1, TCh.Domain.Alternatives';
	}
}

export class UpdateAlternativeCommitmentDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Alternatives.Commands.UpdateAlternativeCommitmentDateCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	CommitmentDate: MonthYear | null;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, commitmentDate: MonthYear | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = alternativeId;
		this.CommitmentDate = commitmentDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Alternatives.Commands.UpdateAlternativeCommitmentDateCommandV1, TCh.Domain.Alternatives';
	}
}